import React, { useState, useEffect } from "react";
import "../../styles/ProjectSliderStyles.css";
import API_URL from "../../config";

const ProjectSlider = () => {
  const [projects, setProjects] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        // 1) Petición a Projects
        const responseProjects = await fetch(`${API_URL}/api/projects`);
        if (!responseProjects.ok) {
          throw new Error(`Error en /projects: ${responseProjects.status}`);
        }
        const { data: dataProjects } = await responseProjects.json();

        // 2) Petición a Properties
        const responseProperties = await fetch(`${API_URL}/api/properties`);
        if (!responseProperties.ok) {
          throw new Error(`Error en /properties: ${responseProperties.status}`);
        }
        const { data: dataProperties } = await responseProperties.json();

        // 3) Combinar
        setProjects([...dataProjects, ...dataProperties]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchItems();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? projects.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="project-slider-container">
      <button className="slider-control slider-left" onClick={prevSlide}>
        &#8249;
      </button>

      <div className="project-slider-wrapper">
        {projects.map((project, index) => {
          // Calcular las posiciones para 4 imágenes visibles
          const position =
            index === currentIndex
              ? "active"
              : index === (currentIndex - 1 + projects.length) % projects.length
              ? "prev"
              : index === (currentIndex + 1) % projects.length
              ? "next"
              : index === (currentIndex - 2 + projects.length) % projects.length
              ? "prev-prev"
              : index === (currentIndex + 2) % projects.length
              ? "next-next"
              : "hidden";

          return (
            <div key={project._id || index} className={`slider-item ${position}`}>
              {/* Imagen y contenido */}
              <div className="image-overlay">
                <img
                  src={`${API_URL}/uploads/${project.images[0]}`}
                  alt={project.title}
                  className="slider-image"
                />
                {/* Información sobre la imagen */}
                <div className="slider-info">
                  <span className="slider-number">{index + 1}</span>
                  <h2 className="slider-title">{project.title}</h2>
                  <p className="slider-type">{project.status || "Sin estado"}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="slider-control slider-right" onClick={nextSlide}>
        &#8250;
      </button>
    </div>
  );
};

export default ProjectSlider;
